// Small helpers of Comercial's screens that need the browser or the app's
// language (so they stay out of the node-tested *Logica.js files).
import { currentLocale } from '../../i18n'
import { comoUtc } from './organizacionesLogica'

// "Name · date" for who did something and when.
export function quien(t, usuario, cuando) {
  const fecha = cuando ? new Date(comoUtc(cuando)).toLocaleString(currentLocale(), { dateStyle: 'medium', timeStyle: 'short' }) : ''
  return [usuario?.display_name || t('ficha.alguien'), fecha].filter(Boolean).join(' · ')
}

// Text to the clipboard. Where the clipboard API isn't allowed, the old
// copy command; if that fails too, it throws (never a false "copied").
export async function copiarAlPortapapeles(texto) {
  try {
    await navigator.clipboard.writeText(texto)
    return
  } catch { /* falls back below */ }
  const ta = document.createElement('textarea')
  ta.value = texto
  ta.setAttribute('readonly', '')
  ta.style.position = 'fixed'
  ta.style.opacity = '0'
  document.body.appendChild(ta)
  ta.select()
  let ok = false
  try { ok = document.execCommand('copy') } finally { document.body.removeChild(ta) }
  if (!ok) throw new Error('copy failed')
}

// A choice kept in the browser (columns); `validar` cleans what was saved.
export function leerLocal(clave, validar) {
  try { return validar(JSON.parse(localStorage.getItem(clave))) } catch { return validar(null) }
}
export function guardarLocal(clave, valor) {
  try { localStorage.setItem(clave, JSON.stringify(valor)) } catch { /* private mode */ }
}
